import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo11 } from "../../../routes/Module11";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo11/terreno.png";
import Imagen2 from "../../../images/modulo11/ladrones.png";
import Imagen3 from "../../../images/modulo11/demolercasa.png";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 9.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[8];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo11.content[0].activities[9].name}`,
    linkNext: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[9].path}`,
    titlePrev: `${modulo11.content[0].activities[7].name}`,
    linkPrev: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo11.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="">
        <li>El Poder Judicial tiene entre sus funciones las siguientes:</li>
      </ul>
      <div className="ms-3">
        <p>a{")"} castigar a quien comete delitos,</p>
        <p>b{")"} resolver conflictos entre las personas,</p>
        <p>
          c{")"} defender a las personas cuando dañan sus derechos
          fundamentales.
        </p>
      </div>
      <ul>
        <li>Observa los siguientes casos.</li>
        <li>
          Con un compañero, compañera o familiar, decidan cuál de las 3
          funciones del Poder Judicial antes mencionada corresponde a cada caso
          y escríbanla.
        </li>
      </ul>
      <Card>
        <h5 className="mb-2">Caso 1</h5>
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-6 col-12">
            <img src={Imagen1} alt="Electores" className="img-fluid" />
          </div>
          <div className="col-lg-7 col-md-6 col-12">
            <textarea className="form-control" rows={6} />
          </div>
        </div>
      </Card>
      <Card>
        <h5 className="mb-2">Caso 2</h5>
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-6 col-12">
            <img src={Imagen2} alt="Electores" className="img-fluid" />
          </div>
          <div className="col-lg-7 col-md-6 col-12">
            <textarea className="form-control" rows={6} />
          </div>
        </div>
      </Card>
      <Card>
        <h5 className="mb-2">Caso 3</h5>
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-6 col-12">
            <img src={Imagen3} alt="Electores" className="img-fluid" />
          </div>
          <div className="col-lg-7 col-md-6 col-12">
            <textarea className="form-control" rows={6} />
          </div>
        </div>
      </Card>

      <GuiaDocente>
        <p>
          Lea las indicaciones y observen las viñetas. Confirme que se han
          comprendido las tres funciones del Poder Judicial. Ayude a realizar la
          actividad y pida que expliquen sus elecciones.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
